module.exports = __webpack_public_path__ + "img/bgdTG.41257392.svg";